import contractIcon from '@/images/chart/contract@2x.png';
import contractBag1 from '@/images/chart/contract-1@2x.png';
import grossMarginIcon from '@/images/chart/gross-margin@2x.png';
import grossMarginBag1 from '@/images/chart/gross-margin-1@2x.png';
import grossMarginBag2 from '@/images/chart/gross-margin-2@2x.png';
import cashReturnIcon from '@/images/chart/cash-return@2x.png';
import cashReturnBag1 from '@/images/chart/cash-return-1@2x.png';
import cashReturnBag2 from '@/images/chart/cash-return-2@1x.png';
import costIcon from '@/images/chart/cost@2x.png';
import costBag1 from '@/images/chart/cost-1@2x.png';

const CHART_TOTAL_BLOCK_PROPS = {
  totalOrder: {
    tipIcon: contractIcon,
    tipText: '订单总量',
    backgroundColor: '#0084E7',
    backgroundImage: contractBag1,
    theme: 0,
  },
  totalSuccessRate: {
    tipIcon: contractIcon,
    tipText: '总成功率',
    backgroundColor: '#0084E7',
    backgroundImage: contractBag1,
    theme: '0%',
  },
  totalOrderOfProject: {
    tipIcon: contractIcon,
    tipText: '总服务量',
    backgroundColor: '#0084E7',
    backgroundImage: contractBag1,
    theme: 0,
  },
  totalDelivery: {
    tipIcon: contractIcon,
    tipText: '总送达量',
    backgroundColor: '#0084E7',
    backgroundImage: contractBag1,
    theme: 0,
  },
  totalPickUp: {
    tipIcon: contractIcon,
    tipText: '总接起量',
    backgroundColor: '#BB7ADB',
    backgroundImage: costBag1,
    theme: 0,
  },
  totalDeliveryRate: {
    tipIcon: contractIcon,
    tipText: '总送达率',
    backgroundColor: '#63A9EF',
    backgroundImage: grossMarginBag1,
    theme: '0%',
  },
};

export default CHART_TOTAL_BLOCK_PROPS;
